// 引入localStorage相关方法
import { getStorage, setStorage, cleanStorage } from '@/utils/myUtils';

/**
 * 人员信息模块（包含账号信息和员工信息）
 * token：token值
 * userMessage：账号信息
 * uid:企业id
 * */
const userModule = {
  state: {
    token: getStorage('token'),
    userMessage: getStorage('usermessage'),
    busnessInfo: ''
  },
  mutations: {
    // 设置token
    SET_TOKEN: (state, token) => {
      setStorage('token', token)
      state.token = token
    },
    // 设置账户信息缓存
    SET_USERMESSAGE: (state, data) => {
      setStorage('usermessage', data)
      state.userMessage = data
    },
    // 保存企业信息，用于判断权限
    SET_BUSINESS_INFO: (state, data) => {
      state.busnessInfo = data
    },
    // 清除用户数据
    CLEAN_USER_INFO (state) {
      cleanStorage('token')
      cleanStorage('usermessage')
    },
    // 把登录的token切换成企业端用的btoken 以免混乱/ 不用了
    CHANGE_BUSNESS (state) {
      console.log('gettoken')
    }
  },
  actions: {}
}

export default userModule



// WEBPACK FOOTER //
// ./src/store/modules/userModule.js